import { ref } from 'vue'

// Module-level state on purpose: one queue for the whole app, so any component
// can raise a toast without the shell having to pass anything down.
const toasts = ref([])
let nextId = 1

export function useToast() {
  function show({ level = 'info', title = '', message = '', duration = 4500 }) {
    const id = nextId++
    toasts.value.push({ id, level, title, message })
    if (duration > 0) setTimeout(() => dismiss(id), duration)
    return id
  }

  function dismiss(id) {
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index !== -1) toasts.value.splice(index, 1)
  }

  return {
    toasts,
    show,
    dismiss,
    success: (message, title) => show({ level: 'success', message, title }),
    // Errors stay until dismissed: a failure that vanishes in four seconds is a
    // failure the user never read.
    error:   (message, title) => show({ level: 'danger', message, title, duration: 0 }),
    warning: (message, title) => show({ level: 'warning', message, title }),
    info:    (message, title) => show({ level: 'info', message, title }),
  }
}
